
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 17 15","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"hwvLoj.tif_28_","opacity":".45"}},[_c('path',{staticClass:"st1",attrs:{"d":"M1.3 4.2c.1-.2.1-.5.2-.7.4-1.1 1.3-1.7 2.5-1.8h5.8c.2 0 .4.3.4.6s-.3.5-.6.6H4.2c-.7 0-1.3.4-1.6 1.1 0 .1-.1.3-.1.5v7.4c0 .9.7 1.6 1.6 1.6h7.5c.9 0 1.6-.7 1.6-1.6V6.7c0-.3.2-.6.4-.7.4-.1.8.1.8.5v5.3c0 1.2-.6 2.1-1.7 2.6-.4.2-.8.2-1.2.2H4c-1.4 0-2.5-.9-2.8-2.2 0-.1 0-.2-.1-.4.2-2.5.2-5.1.2-7.8z"}}),_c('path',{staticClass:"st1",attrs:{"d":"M14.1.3c.2 0 .3.1.5.1 1.2.5 1.5 2 .7 2.9-.8.8-1.5 1.7-2.3 2.5-1.3 1.5-2.7 2.9-4 4.4-.1.1-.2.2-.4.3-.7.3-1.4.6-2 .9-.4.2-.8.1-1-.2-.2-.3-.2-.6-.1-.9 0-.7.2-1.4.5-2.1 0-.1.1-.2.2-.3L12.5 1c.3-.3.7-.6 1.2-.6.1-.1.3-.1.4-.1zM8.8 8.5l.2-.2c1.5-1.7 3-3.3 4.5-5 .3-.3.5-.6.8-.9.3-.4.1-.9-.3-1-.2-.1-.4.1-.6.2-1.5 1.7-3.1 3.3-4.6 5-.2.5-.5.8-.8 1.1.3.2.6.5.8.8zM6.7 10c.4-.2.9-.4 1.3-.6-.3-.3-.6-.5-.9-.8-.1.5-.3.9-.4 1.4z"}})])])
          )
        }
      }
    